/* eslint-disable */
<template>
  <div class="admin-client-contacts">
    <AdminNavigation ref="navigation" indexProps="2" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Client Contacts ({{ totalCount }})</h1></div>
        <div class="header-sub-title">Click to view, edit the details of a client contact.</div>
      </div>
    </div>
    <div class="panel">
      <AdminClientsMenu :indexProps="3" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <img v-if="listParam.ClientName || listParam.BranchName || listParam.ContactName || listParam.ClientID || listParam.ClientContactID || Number.isInteger(listParam.IsActive)" class="mr-2" src="@/assets/images/close_icon.svg" @click="cancelSearch" title="Cancel Search"/>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Client Name" v-model="listParam.ClientName"/>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Branch Name" v-model="listParam.BranchName"/>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Contact Name" v-model="listParam.ContactName"/>
              <el-select v-model="listParam.IsActive" placeholder="Is Active" clearable @change="selectPage(1)">
                <el-option :value="1" label="Active">Active</el-option>
                <el-option :value="0" label="Inactive">Inactive</el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div v-if="fetchedData" class="content-scroll-x">
          <div>
            <el-table @row-click="RowClick" :default-sort="{prop: 'ClientContactID', order: 'descending'}" :data="allContacts" stripe @sort-change="sortParam" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
              <el-table-column
                  width="80"
                  show-overflow-tooltip
                  label="ID"
                  sortable="custom"
                  prop="ClientContactID"
              >
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  label="Full Name"
                  sortable="custom"
                  prop="ContactName"
              >
                <template slot-scope="contact">
                  {{decodeURIComponent(contact.row.FirstName + " " + (contact.row.MiddleName ? contact.row.MiddleName + " " : "") + contact.row.Surname)}}
                </template>
              </el-table-column>
              <el-table-column
                  width="180"
                  show-overflow-tooltip
                  label="Client & Branch"
                  sortable="custom"
                  prop="ClientAndBranch"
              >
                <template slot-scope="contact">
                  {{decodeURIComponent( contact.row.Client.ClientName + ' ' + contact.row.Client.BranchName)}}
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  label="Email"
                  prop="ClientContactID"
              >
                <template slot-scope="contact">
                  {{decodeURIComponent( contact.row.EmailAddress)}}
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  label="Mobile"
                  prop="ClientContactID"
              >
                <template slot-scope="contact">
                  {{decodeURIComponent( contact.row.Mobile ? contact.row.Mobile: '')}}
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  label="User Login?"
                  prop="ClientContactID"
              >
                <template slot-scope="contact">
                  <input type="checkbox" :checked="!!contact.row.CanLogin" />
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  label="Primary User?"
                  prop="ClientContactID"
              >
                <template slot-scope="contact">
                  <input type="checkbox" :checked="!!contact.row.IsPrimaryContact" />
                </template>
              </el-table-column>
              <el-table-column
                  width="80"
                  show-overflow-tooltip
                  label="Role"
                  prop="ClientContactID"
              >
                <template slot-scope="contact">
                  {{decodeURIComponent( contact.row.User ? contact.row.User.Role.RoleName : '')}}
                </template>
              </el-table-column>
              <el-table-column
                  width="120"
                  show-overflow-tooltip
                  label="Is active"
                  prop="Active"
              >
                <template slot-scope="contact">
                  <input type="checkbox" :checked="!!contact.row.Active" />
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <div class="icon-group" @click.stop="">
                    <el-tooltip v-if="scope.row.ZohoLink" effect="dark" content="Link to Zoho" placement="bottom">
                      <a v-if="scope.row.ZohoLink" :href="scope.row.ZohoLink" target="_blank" @click.stop="">
                        <img class="me-2" src="@/assets/images/zoho_icon.svg"/></a>
                    </el-tooltip>
                    <EditZohoLinkDialog @updateSuccess="updateSuccess" :id="scope.row.ClientContactID" :index="scope.$index" type="contact" />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import AdminNavigation from '@/components/AdminNavigation'
  import Header from '@/components/Header'
  import AdminClientsMenu from '@/components/AdminClientsMenu'
  import { debounce } from 'lodash'
  import EditZohoLinkDialog from "@/components/dialog/EditZohoLinkDialog";
  export default {
    name: 'AdminClientContacts',
    props: ["searchOptionClientProps", "searchOptionContactProps"],
    components: {
      AdminNavigation,
      Header,
      AdminClientsMenu,
      EditZohoLinkDialog
    },
    data() {
      return {
        fetchedData: false,
        totalCount: 0,
        contacts: [],
        allContacts: [],
        limit: 20,
        pagination: utilities.initPagination(),
        contactsNumber: 0,
        searchTerm: '',
        clientId: '',
        listParam: {
          pageNum: 1,
          pageSize: 10,
          sortBy: 'ClientContactID',
          ClientID: '',
          ClientContactID: '',
          IsActive: null,
          ClientName: '',
          BranchName: '',
          ContactName: ''
        },
        clientMenuIndex: 0,
      }
    },
    methods: {
      search: debounce(function () {
        this.selectPage(1)
      }, 800),
      RowClick(row) {
        this.$router.push({ name: 'admin-edit-client-contact', query: { id: row.ClientContactID } })
      },
      cancelSearch() {
        this.useSearch = false
        this.listParam.ClientContactID = ""
        this.listParam.ClientID = ""
        this.listParam.ContactName = ""
        this.listParam.ClientName = ""
        this.listParam.BranchName = ""
        this.listParam.IsActive = null
        window.history.replaceState({}, document.title, location.pathname)
        this.selectPage(1)
      },
      updateSuccess(index, newLink) {
        this.loadData()
      },
      sortParam(v) {
        this.listParam.orderBy = v.prop
        if(v.order === "ascending") {
          this.listParam.ascOrDesc = 'ASC'
        } else if (v.order === "descending") {
          this.listParam.ascOrDesc = 'DESC'
        } else {
          this.listParam.orderBy = null
          this.listParam.ascOrDesc = null
        }

        this.selectPage(1)
      },
      selectPage(index) {
        this.listParam.pageNum = index
        console.log(this.listParam)
        this.loadData()
      },
      async searchClientContact(searchOption) {
        window.history.replaceState({}, document.title, location.pathname)
        this.listParam.ContactName = searchOption.name
        this.listParam.ClientName = searchOption.ClientName
        this.listParam.BranchName = searchOption.BranchName
        this.listParam.IsActive = searchOption.IsActive
        this.selectPage(1)
      },

      async loadData() {
        await this.$store.dispatch('loading/setLoadComponent', true)
        let param = {}
        for (let i in this.listParam) {
          if (this.listParam[i] !== undefined && this.listParam[i] !== null && this.listParam[i] !== "") param[i] = this.listParam[i]
        }
        const {contacts, total} = await utilities.getClientContactsNew(param)
        this.allContacts = contacts
        this.totalCount = total
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
    },
    async beforeMount() {
      if(this.searchOptionContactProps) {
        this.listParam.BranchName = this.searchOptionContactProps.BranchName
        this.listParam.ClientName = this.searchOptionContactProps.ClientName
        this.listParam.ContactName = this.searchOptionContactProps.name
        this.listParam.IsActive = this.searchOptionContactProps.IsActive
        await this.loadData()
      } else {
        this.listParam.ClientContactID = this.$route.query.id !== undefined ? this.$route.query.id : ''
        this.listParam.ClientID = this.$route.query.clientId !== undefined ? this.$route.query.clientId : ''
        await this.loadData()
      }
      this.fetchedData = true
    }
  }
</script>
